import { track } from '@vercel/analytics'

export type ImageLoadFailureCategory = 'avatar' | 'embed' | 'banner' | 'other'

export interface ImageLoadFailureEvent {
    category: ImageLoadFailureCategory
    origin: string
    swControlled: boolean
}

export function trackImageError(category: ImageLoadFailureCategory, src: string | undefined) {
    let origin = 'unknown'
    try {
        if (src)
            origin = new URL(
                src,
                typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
            ).origin
    } catch {
        // leave 'unknown'
    }
    // TODO: sample if event volume becomes a problem
    track('image-load-failure', {
        category,
        origin,
        swControlled:
            typeof navigator !== 'undefined' && navigator.serviceWorker?.controller != null,
    } satisfies ImageLoadFailureEvent)
}
